/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Summary_Remaining_Chars_Cps_TitleInputs */



/**
* | output |
* | --- |
* | "Remaining Characters to CPS" |
*
* @param {Summary_Remaining_Chars_Cps_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const summary_remaining_chars_cps_title = /** @type {((inputs?: Summary_Remaining_Chars_Cps_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Summary_Remaining_Chars_Cps_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Caracteres restants au CPS")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verbleibende Zeichen bis CPS")
	if (locale === "it") return /** @type {LocalizedString} */ ("Personaggi rimanenti per CPS")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Оставшиеся символы для CPS")
	if (locale === "es") return /** @type {LocalizedString} */ ("Personajes restantes para CPS")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("剩余字符数至 CPS")
	if (locale === "ja") return /** @type {LocalizedString} */ ("残りの文字はCPSへ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शेष पात्रों को सीपीएस को सौंपना है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Personagens restantes para o CPS")
	return /** @type {LocalizedString} */ ("Remaining Characters to CPS")
});